import { motion } from 'framer-motion';
import { Typewriter } from 'react-simple-typewriter';

const TypewriterText = () => {
  const wordPairs = [
    ["Software", "Engineer"],
    ["AI", "Enthusiast"],
    ["Tech", "Explorer"],
  ];

  return (
    <motion.h1
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5 }}
      className="text-6xl font-extrabold leading-tight"
    >
      <Typewriter
        words={wordPairs.map((pair) => `${pair[0]} \n ${pair[1]}`)}
        loop={true}
        cursor
        cursorStyle="|"
        typeSpeed={100}
        deleteSpeed={50}
        delaySpeed={2000}
      />
    </motion.h1>
  );
};

export default TypewriterText;